import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OrganizationState {
  operationMode: 'standalone' | 'connected';
  ehrIntegration?: {
    provider: string;
    apiEndpoint: string;
    lastSync?: Date;
    status: 'active' | 'inactive' | 'error';
  };
  /**
   * Whether this user may start a recording (AMP-136), from the server's capabilities. null until
   * they have loaded. Not persisted: it belongs to the signed-in user, not the browser.
   */
  canRecord: boolean | null;
  setCanRecord: (canRecord: boolean | null) => void;
  setOperationMode: (mode: 'standalone' | 'connected') => void;
  setEhrIntegration: (integration: OrganizationState['ehrIntegration']) => void;
}

export const useOrganizationStore = create<OrganizationState>()(
  persist(
    (set) => ({
      operationMode: 'standalone',
      ehrIntegration: undefined,
      canRecord: null,

      setCanRecord: (canRecord) => set({ canRecord }),
      
      setOperationMode: (mode) => set({ operationMode: mode }),
      
      setEhrIntegration: (integration) => set({ ehrIntegration: integration }),
    }),
    {
      name: 'organization-storage',
      partialize: (state) => ({ operationMode: state.operationMode, ehrIntegration: state.ehrIntegration }),
    }
  )
);